import { render, staticRenderFns } from "./Contact_US.vue?vue&type=template&id=edf00d18&scoped=true"
import script from "./Contact_US.vue?vue&type=script&lang=js"
export * from "./Contact_US.vue?vue&type=script&lang=js"
import style0 from "./Contact_US.vue?vue&type=style&index=0&id=edf00d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf00d18",
  null
  
)

export default component.exports